import { createSlice } from "@reduxjs/toolkit";
import { TAppState } from "..";
import { PA } from "@/types/utility.types";

export type ObjectType = 'portfolio' | 'run';

type  ShareModalState = {
  show: boolean;
  objectId: string;
  objectType: ObjectType;
  objectName: string;
}


const initialState: ShareModalState = {
  show: false,
  objectId: '',
  objectType: 'portfolio',
  objectName: '',
};

const shareModal = createSlice({
  name: "shareModal",
  initialState,
  reducers: {
    openShareModal: (state, action: PA<{ objectId: string, objectType: ObjectType, objectName: string }>) => {
      state.show = true;
      state.objectId = action.payload.objectId;
      state.objectType = action.payload.objectType;
      state.objectName = action.payload.objectName;
    },
    closeShareModal: (state) => {
      state.show = false;
    },
  },
});

export const shareModalActions = shareModal.actions;
export const shareModalReducer = shareModal.reducer;

export const shareModalSelector = (state: TAppState) => state.shareModal;
export const selectIsShareModalOpen = (state: TAppState) => Boolean(state.shareModal.show);
export const selectObjectId = (state: TAppState) => state.shareModal.objectId;
export const selectObjectType = (state: TAppState) => state.shareModal.objectType;
export const selectObjectName = (state: TAppState) => state.shareModal.objectName;